export default __webpack_public_path__ + "static/media/service_banner.2ea91425.jpg";